// extracted by mini-css-extract-plugin
module.exports = {"imgNav":"Navbar_imgNav__2WSD_","navText":"Navbar_navText__2Uh2I","navLogo":"Navbar_navLogo__1pmLl","imgLogo":"Navbar_imgLogo__BmTeV"};